import { css } from 'styled-components';

export default css`
  .accordion {
    margin-bottom: 8px;
    padding: 3px 10px;
    position: relative;
    background: rgb(249, 249, 249);
    border-radius: 2px;
    line-height: initial;
    cursor: pointer;
    box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.2);

    &:after {
      content: '+';
      height: 100%;
      margin: 0 16px;
      position: absolute;
      right: 0;
      top: 0;
      font-weight: bold;
      font-size: 2.4em;
      line-height: 100%;
      color: #777;
    }

    .panel {
      display: none;
    }

    .accordion-button {
      margin: 10px 0;
    }

    &.active {
      .panel {
        display: block;
        margin: 8px 0;
        color: black;

        p {
          color: black;
        }
      }
    }
  }
`;
